import React from 'react'
import { Card } from 'antd-mobile'
import '../styles/ExerciseCard.css'
import { formatLabel } from '../../../utils'

function ExerciseCard({ activity = {}, onClick, onEdit, isAdaptive = false, isProgramItem = false }) {
  const {
    id,
    category = '--',
    workout_type = '--',
    duration = 0,
    intensity = '--',
    type = '--',
    program_item_id = null,
    manual: isManualWorkout = false
  } = activity

  const getItemType = () => {
    if (isAdaptive) return 'Adaptive'
    if (program_item_id != null) return 'Program'
    return 'Non Program'
  }

  const durationInMinutes = Math.abs(Math.round((Number(duration) || 0) / 60))
  const itemType = getItemType()

  const handleEditClick = (e) => {
    e.stopPropagation()
    if (onEdit && typeof onEdit === 'function') {
      onEdit(activity)
    }
  }

  return (
    <Card
      key={id}
      className="exercise-card"
      bodyStyle={{ padding: '22px 2px' }}
      onClick={() => onClick?.(activity)}
      style={{
        borderLeft: isAdaptive ? '4px solid #006400' : '4px solid rgb(13, 35, 80)'
      }}
    >
      <div
        className="exercise-card-top-row"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <span
          className="adaptive-tag"
          style={{
            backgroundColor:
              itemType === 'Non Program'
                ? 'rgb(165, 168, 173)'
                : isAdaptive
                  ? '#006400'
                  : 'rgb(127, 184, 0)'
          }}
        >
          {itemType}
        </span>
        {(isManualWorkout || isAdaptive) && (
          <div className="edit-button" onClick={handleEditClick}>
            Edit
          </div>
        )}
      </div>

      <div className="exercise-meta-container">
        <div>
          <div className="exercise-title">
            {isProgramItem
              ? (() => {
                const title = activity?.details?.activity_classification || activity?.category
                return title ? `${title}:` : '--'
              })()
              : category
                ? `${category}:`
                : '--'}
          </div>

          <div className="exercise-subtitle" style={{ marginTop: '2px', width: '100px'}}>
            {isProgramItem
              ? formatLabel(activity?.details?.activity_type_shown || activity?.details?.activity_type || '--')
              : formatLabel(workout_type || '--')}
          </div>

        </div>
        <div className="exercise-meta-subcontainer">
          <div>
            <div className="exercise-meta-label">TIME</div>
            <div className="exercise-meta-value">{durationInMinutes} M</div>
          </div>
          <div>
            <div className="exercise-meta-label">INTENSITY</div>
            <div className="exercise-meta-value">{intensity || '--'}</div>
          </div>
        </div>
      </div>
    </Card>
  )
}

export default ExerciseCard
